
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { TopBot } from '@/types/top-bots';

export const useTopBots = (limit: number = 3) => {
  return useQuery({
    queryKey: ['topBots', limit],
    queryFn: async (): Promise<TopBot[]> => {
      const { data, error } = await supabase
        .from('top_bots')
        .select('*')
        .order('connected_accounts_total', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return data || [];
    }
  });
};

